import { XCircle } from '@phosphor-icons/react';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';

const ErrorAndRetry = ({ message = '', handleRetry = noop }) => {
  return (
    <div className="absolute flex w-full h-full justify-center items-center top-0 bottom-0 left-0 right-0">
      <div className="flex flex-col items-center gap-4">
        <XCircle className="text-brandPrimary w-20 h-20" weight="thin" />
        <span className="text-center">{message}</span>
        <span>
          <a
            onClick={handleRetry}
            className="underline text-brandLink cursor-pointer text-center"
          >
            Please Retry
          </a>
          &nbsp;,&nbsp;Let us know if the issue persists.
        </span>
      </div>
    </div>
  );
};

ErrorAndRetry.propTypes = {
  message: PropTypes.string,
  handleRetry: PropTypes.func,
};

export default ErrorAndRetry;
